import { render, staticRenderFns } from "./tour.vue?vue&type=template&id=175e688c"
import script from "./tour.vue?vue&type=script&lang=js"
export * from "./tour.vue?vue&type=script&lang=js"
import style0 from "./tour.vue?vue&type=style&index=0&id=175e688c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports